import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postreadCountAnnouncementsSlice = createApi(`PostreadCountAnnouncementsSlice`,"POST");

const PostreadCountAnnouncementsSlice = createSlice({
  name: 'PostreadCountAnnouncementsSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postreadCountAnnouncementsSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postreadCountAnnouncementsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postreadCountAnnouncementsSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostreadCountAnnouncementsSlice.reducer;